import {
  Component,
  OnInit,
  signal,
  inject,
  input,
  output
} from "@angular/core";
import {
  IQueue,
  NotificationService,
  extractErrorMessage
} from "../../../../../core-ui";
import { SmsService } from "../../../../services/sms.service";
import { TranslateService } from "@ngx-translate/core";
import { UntypedFormGroup } from "@angular/forms";
import {
  GenesysInteraction,
  GenesysInvitationChannelEnum,
} from "../../../../models";
import { PHONE_REGEX } from "../../../../app.enums";
import { markFormFields } from "../../../../app.utils";

@Component({
  selector: "app-share-link-sms-number",
  templateUrl: "./number.component.html",
  styleUrls: ["./number.component.scss"],
  standalone: false
})
export class ShareLinkSMSNumberComponent implements OnInit {
  private smsService = inject(SmsService);
  private notification = inject(NotificationService);
  private translate = inject(TranslateService);

  readonly interaction = input<GenesysInteraction>(undefined);
  readonly queue = input<IQueue>(undefined);
  readonly channel = input<GenesysInvitationChannelEnum>(undefined);
  readonly link = input<string>(undefined);
  readonly workflow = input<string>(undefined);

  readonly dismiss = output<void>();
  readonly completed = output<void>();

  phonePattern = PHONE_REGEX;
  phoneNumber: string;
  isPostingSMS = signal(false);

  ngOnInit(): void {
    this.phoneNumber = this.interaction().getCustomerPhoneNumber();
  }

  cancelSMS() {
    this.dismiss.emit();
  }

  async sendUsingWorkflow() {
    try {
      this.isPostingSMS.set(true);
      await this.smsService.sendUsingWorkflow({
        flowId: this.workflow(),
        interaction: this.interaction(),
        phoneNumber: this.phoneNumber,
        link: this.link(),
      });
      this.notification.show("auvious", {
        body: this.translate.instant("Workflow executed")
      });
      this.dismiss.emit();
      this.completed.emit();
    } catch (ex) {
      this.notification.error("Could not execute workflow", {
        body: extractErrorMessage(ex)
      });
    } finally {
      this.isPostingSMS.set(false);
    }
  }

  async sendUsingQueue() {
    try {
      this.isPostingSMS.set(true);
      await this.smsService.sendUsingQueue({
        queueId: this.queue().id,
        interaction: this.interaction(),
        phoneNumber: this.phoneNumber,
        link: this.link(),
      });
      this.dismiss.emit();
      this.completed.emit();
      this.notification.show("auvious", {
        body: this.translate.instant(
          "Please check your interactions for a new SMS interaction."
        )
      });
    } catch (ex) {
      this.notification.error(
        (ex.body && ex.body.message) || ex.message || "Could not prepare SMS"
      );
    } finally {
      this.isPostingSMS.set(false);
    }
  }

  async sendSMS(form: UntypedFormGroup) {
    if (form.valid) {
      switch (this.channel()) {
        case GenesysInvitationChannelEnum.queue:
          return this.sendUsingQueue();
        case GenesysInvitationChannelEnum.workflow:
          return this.sendUsingWorkflow();
      }
    } else {
      markFormFields(form);
    }
  }
}
